import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/css/tailwind.css';
import App from './App';
import ReactGA from 'react-ga4';

ReactGA.initialize('G-H97Z2CF1WF');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);
